<template>
  <div class="step-one px-[20px]">
    <div class="form-wrapper grid gap-5 mb-5 grid-cols-4-default" :class="companyActive ? 'md:grid-cols-4-default' : 'md:grid-cols-6-default'">
      <!-- First Name -->
      <div class="col-span-4 md:col-span-2" v-show="!companyActive">
        <label class="font-body text-base text-gray-900" for="first_name">{{ translations.text.first_name }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <input
            v-validate="{ required: !companyActive, alpha_spaces: !companyActive, min: 3, max: 255 }"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('first_name') }"
            name="first_name"
            type="text"
            :data-vv-as="translations.text.first_name"
            :placeholder="translations.text.firstname_placeholder"
            v-model="data.first_name"
            class="text-base text-gray-900 font-semibold"
            :disabled="upgrade"
          />
          <span v-show="errors.has('first_name')" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first('first_name')
          }}</span>
        </div>
      </div>
      <!-- Middle Name -->
      <div class="col-span-4 md:col-span-2" v-show="!companyActive">
        <label class="font-body text-base text-gray-900" for="middle_name">{{ translations.text.middle_name }}</label>
        <div class="my-2">
          <input
            v-validate="{ alpha_spaces: !companyActive, min: 3, max: 255 }"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('middle_name') }"
            name="middle_name"
            type="text"
            :data-vv-as="translations.text.middle_name"
            :placeholder="translations.text.middlename_placeholder"
            v-model="data.middle_name"
            class="text-base text-gray-900 font-semibold"
            :disabled="upgrade"
          />
          <span v-show="errors.has('middle_name')" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first('middle_name')
          }}</span>
        </div>
      </div>
      <!-- Last Name -->
      <div class="col-span-4 md:col-span-2" v-show="!companyActive">
        <label class="font-body text-base text-gray-900" for="last_name">{{ translations.text.last_name }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <input
            v-validate="{ required: !companyActive, alpha_spaces: !companyActive, min: 3, max: 255 }"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('last_name') }"
            name="last_name"
            type="text"
            :data-vv-as="translations.text.last_name"
            :placeholder="translations.text.lastname_placeholder"
            v-model="data.last_name"
            class="text-base text-gray-900 font-semibold"
            :disabled="upgrade"
          />
          <span v-show="errors.has('last_name')" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first('last_name')
          }}</span>
        </div>
      </div>
      <!-- Country of residence -->
      <!-- <div class="col-span-4" :class="companyActive ? 'md:col-span-4' : 'md:col-span-6'">
        <Select
          :key="translations.text.country_of_residence"
          v-model="data.country"
          name="country"
          rules="required"
          :placeholder="translations.text.country_of_residence"
          :options="filteredCountries"
          option-label="name"
          :disabled="true"
          @change="setDialCode"
          :label="translations.text.country_of_residence"
          label-transform="tCapitalizeFirstLetter"
        />
      </div> -->
      <!-- Company name -->
      <div class="col-span-4 md:col-span-2" v-show="companyActive">
        <label class="font-body text-base text-gray-900" for="company">{{ translations.text.company_name }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <input
            v-validate="{ required: companyActive, min: 3, max: 255 }"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('company_name') }"
            name="company_name"
            type="text"
            :data-vv-as="translations.text.company_name"
            :placeholder="translations.text.company_name_placeholder"
            v-model="data.company_name"
            class="text-gray-900 text-base font-semibold"
          />
          <span v-show="errors.has('company_name')" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first('company_name')
          }}</span>
        </div>
      </div>
      <!-- Company website -->
      <div class="col-span-4 md:col-span-2" v-show="companyActive">
        <label class="font-body text-base text-gray-900" for="website">{{ translations.text.company_website }}</label>
        <div class="my-2">
          <input
            v-validate="{ min: 3, max: 255 }"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('website') }"
            name="website"
            type="text"
            :data-vv-as="translations.text.company_website"
            :placeholder="translations.text.website"
            v-model="data.website"
            class="text-gray-900 text-base font-semibold"
          />
          <span v-show="errors.has('website')" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first('website')
          }}</span>
        </div>
      </div>
      <!-- Dial code -->
      <div class="col-span-2 md:col-span-2 relative" v-show="!upgrade" :class="companyActive ? 'xl:col-span-1' : 'xl:col-span-2'">
       <!-- Dial code -->
        <label class="font-body text-base text-gray-900" for="dialCode">{{ translations.text.dial_code }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <SearchableSelect
            ref="dialCode"
            v-model="data.dialCode"
            :options="countriesDialCodes"
            label-key="label"
            value-key="value"
            track-by="countryCode"
            name="dialCode"
            rules="required"
            :data-vv-as="translations.text.dial_code"
            :placeholder="translations.text.dial_code"
            :disabled="upgrade"
            :option-image="getCountryFlag"
            :filter-fn="(opt, q) => opt.label.toLowerCase().includes(q) || opt.name.toLowerCase().includes(q) || opt.countryCode.toLowerCase().includes(q)"
          />
          <span v-show="errors.has('dialCode')" class="font-body text-xs text-orange font-semibold mt-1 block">{{ errors.first('dialCode') }}</span>
      </div>

      </div>
      <!-- Phone number -->
      <div class="col-span-2" v-show="!upgrade" :class="companyActive ? 'md:col-span-2 xl:col-span-3' : 'md:col-span-4 xl:col-span-4'">
        <div class="">
          <label class="font-body text-base text-gray-900" for="phone">{{ translations.text.phone }}<span class="text-orange ml-1">*</span></label>
        </div>

        <div class="my-2">
          <span class="">
            <input
              v-validate="'required|numeric|max:15'"
              class="text-gray-900 text-base font-semibold"
              :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('phone') }"
              name="phone"
              type="text"
              :data-vv-as="translations.text.phone"
              :placeholder="translations.text.phone"
              v-model="data.phone"
              :disabled="upgrade"
            />
            <span v-show="errors.has('phone')" class="font-body text-xs text-orange font-semibold">{{ errors.first('phone') }}</span>
          </span>
        </div>
      </div>
      <!-- Email -->
      <div class="col-span-4" :class="companyActive ? 'md:col-span-4' : 'md:col-span-6'">
        <label class="font-body text-base text-gray-900" for="email">{{ translations.text.email }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <input
            v-validate="'required|email-available|max:255'"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': invalidEmail || errors.has('email') }"
            name="email"
            type="text"
            :data-vv-as="translations.text.email"
            :placeholder="translations.text.email"
            v-model.trim="data.email"
            autocomplete="off"
            @blur="checkEmailValidation()"
            class="text-base text-gray-900 font-semibold"
            :disabled="upgrade"
          />
          <span v-show="invalidEmail" class="font-body text-xs text-orange font-semibold">{{ $t('invalid_email') }}</span
          ><br />
          <span v-show="errors.has('email')" class="font-body text-xs text-orange font-semibold">{{ errors.first('email') }}</span>
        </div>
      </div>
      <!-- Password -->
      <div v-if="!upgrade" class="col-span-4" :class="companyActive ? 'md:col-span-2' : 'md:col-span-3'">
        <label class="font-body text-base text-gray-900" for="password">{{ translations.text.password }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2 relative">
          <input
            v-validate="{ required: true, 'strong-password': data.password }"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('password') }"
            name="password"
            type="text"
            :data-vv-as="translations.text.password"
            :placeholder="translations.text.password"
            autocomplete="off"
            @input="$event => passwordChanged($event, 'password')"
            :value="showPassword ? data.password : passwordValueMask(data.password)"
            @paste.prevent
            @blur="validateField('password')"
            class="text-gray-900 text-base font-semibold"
          />
          <span class="absolute ltr:right-[18px] rtl:left-[18px] top-[18px] focus:border-none focus:outline-none cursor-pointer" @click="showPassword = !showPassword">
            <img src="@/assets/img/settings-eye-hidden.svg" width="20" alt="show password" v-if="showPassword" />
            <img src="@/assets/img/settings-eye-shown.svg" width="20" alt="hide password" v-if="!showPassword" />
          </span>
          <span v-show="errors.has('password')" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first('password')
          }}</span>
        </div>
      </div>
      <!-- Confirm Password -->
      <div v-if="!upgrade" class="col-span-4" :class="companyActive ? 'md:col-span-2' : 'md:col-span-3'">
        <label class="font-body text-base text-gray-900" :class="{ 'has-text-right': Language == 'fa' }" for="confirm_password"
          >{{ translations.text.confirm_password }}<span class="text-orange ml-1">*</span></label
        >
        <div class="my-2 relative">
          <input
            v-validate="{ required: true, 'custom-confirmed': [data.password, data.confirm_password] }"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('confirm_password') }"
            name="confirm_password"
            type="text"
            :data-vv-as="translations.text.confirm_password"
            :placeholder="translations.text.confirm_password"
            autocomplete="off"
            @input="$event => passwordChanged($event, 'confirm_password')"
            :value="showConfirmPassword ? data.confirm_password : passwordValueMask(data.confirm_password)"
            @paste.prevent
            @blur="validateConfirmPassword()"
            class="text-base text-gray-900 font-semibold"
          />
          <span
            class="absolute ltr:right-[18px] rtl:left-[18px] top-[18px] focus:border-none focus:outline-none cursor-pointer"
            @click="showConfirmPassword = !showConfirmPassword"
          >
            <img src="@/assets/img/settings-eye-hidden.svg" width="20" alt="show password" v-if="showConfirmPassword" />
            <img src="@/assets/img/settings-eye-shown.svg" width="20" alt="hide password" v-if="!showConfirmPassword" />
          </span>
          <!-- <span v-show="passwordsNotMatch" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            $t('passwords_dont_match')
          }}</span> -->
          <span v-show="errors.has('confirm_password')" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first('confirm_password')
          }}</span>
        </div>
      </div>
      <!-- Social media platform -->
      <div v-if="!upgrade" class="col-span-4" :class="companyActive ? 'md:col-span-2' : 'md:col-span-3'">
        <!-- <label
          class="font-body text-base text-gray-900  "
          :class="{ 'has-text-right': Language == 'fa' }"
          for="social_platform"
        >{{ translations.text.social_platform }}<span class="text-orange ml-1">*</span></label>
        <div class="my-2">
          <span class="select is-fullwidth">
            <select
              v-validate="'required'"
              name="social_platform"
              v-model="data.social_platform"
              class="text-base text-gray-900 font-semibold rtl:bg-left"
              :disabled="upgrade"
              :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('social_platform') }"
              :data-vv-as="translations.text.social_platform"
            >
              <option
                value=""
                disabled
                selected
                hidden
              >{{ translations.text.social_platform }}</option>
              <option
                v-for="(item, index) in availablePlatforms"
                :value="item"
                :key="index"
              >
                {{ item.includes('referred') ? $t('referred').tTitle() : item === 'x' ? 'X (Twitter)' : item === 'other' ? $t('other_text') : item.tTitle() }}
              </option>
            </select>
            <span
              v-show="errors.has('social_platform')"
              class="font-body text-xs text-orange font-semibold"
              :class="{ 'has-text-right': Language == 'fa' }"
            >{{
              errors.first('social_platform')
            }}</span>
          </span>
        </div> -->
        <Select
          :key="translations.text.social_platform"
          v-model="data.social_platform"
          name="social_platform"
          rules="required"
          :placeholder="translations.text.social_platform"
          :options="availablePlatforms"
          option-label="label"
          :disabled="upgrade"
          :label="translations.text.social_platform"
          :labelCustomCss="{ 'h-12': data.social_platform === 'other' }"
        />
      </div>
      <!-- Social media other platform -->
      <div class="col-span-4" :class="companyActive ? 'md:col-span-2' : 'md:col-span-3'" v-show="data.social_platform === 'other'">
        <label class="font-body text-base text-gray-900 tracking-wide block h-12" for="other_social_platform"
          >{{ translations.text.other_social_platform }} <span class="text-orange ml-1">*</span></label
        >
        <div class="my-2">
          <input
            v-validate="{ required: data.social_platform === 'other', min: 3, max: 255 }"
            name="other_social_platform"
            type="text"
            :placeholder="translations.text.other_social_platform"
            :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('other_social_platform') }"
            :data-vv-as="translations.text.other_social_platform"
            v-model="data.other_social_platform"
            class="text-gray-900 text-base font-semibold"
          />
          <span v-show="errors.has('other_social_platform')" class="font-body text-xs text-orange font-semibold" :class="{ 'has-text-right': Language == 'fa' }">{{
            errors.first('other_social_platform')
          }}</span>
        </div>
      </div>
    </div>
    <div class="button-wrapper flex gap-[5%]">
      <Button @click="changePage" customClasses="max-w-[185px]">
        {{ $t('continue').tTitle() }}
      </Button>
    </div>
    <logo-loader />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import config from '../../config'
import LogoLoader from '../LogoLoader.vue'
import Button from '../reusableComponents/Button.vue'
import Select from '../reusableComponents/Select.vue'
import SearchableSelect from '../SearchableSelect.vue'


export default {
  props: {
    accountType: String,
    activeStep: Number,
    isCompany: Boolean,
    translations: Object,
    formData: Object,
    upgrade: Boolean,
    prefilledTestData: Boolean,
    testData: Object,
    detectedCountry: String,
  },
  components: {
    LogoLoader,
    Button,
    Select,
    SearchableSelect,
  },
  data() {
    return {
      page: this.activeStep,
      data: {
        first_name: '',
        middle_name: '',
        last_name: '',
        country: '',
        company_name: '',
        website: '',
        dialCode: '',
        phone: '',
        email: '',
        password: '',
        confirm_password: '',
        social_platform: '',
        other_social_platform: '',
      },
      countries: config.countries,
      hiddenCountries: [
        'AF',
        'AT',
        'BE',
        'BG',
        'HR',
        'CY',
        'CZ',
        'DK',
        'EE',
        'FI',
        'FR',
        'DE',
        'GR',
        'HU',
        'IS',
        'IE',
        'IT',
        'LV',
        'LI',
        'LT',
        'LU',
        'MT',
        'NL',
        'NO',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'ES',
        'SE',
        'GB',
        'US',
        'SY',
        'RU',
        'KP',
        'BY',
        'ZA',
        'ZW',
        'UM',
        'VI',
        'HI',
      ],
      invalidEmail: false,
      showPassword: false,
      showConfirmPassword: false,
      passwordsNotMatch: false,

      // availablePlatforms: ['facebook', 'instagram', 'tiktok', 'x', 'reddit', 'forum', 'youTube', 'telegram', 'discord', 'threads', 'referred', 'other'],
    }
  },
  created() {
    if (this.formData) {
      Object.keys(this.formData).forEach(key => {
        this.data[key] = this.formData[key]
      })
    } else if (this.prefilledTestData && this.testData) {
      // make a clone object of this.testData in order to prevent it from updates coming from the child component
      const clonedTestData = JSON.parse(JSON.stringify(this.testData))
      Object.keys(clonedTestData).forEach(key => {
        this.data[key] = clonedTestData[key]
      })
    }
  },
  mounted() {
    // Preselect country based on detected IP country (if already available)
    this.preselectCountryFromDetectedIP()
  },
  watch: {
    detectedCountry(newVal) {
      // Watch for detectedCountry changes (when API response arrives)
      if (newVal) {
        this.preselectCountryFromDetectedIP()
      }
    },
    'data.first_name'() {
      if (this.data.first_name === 'regtest_123go') {
        this.autofillTestData()
      }
    },
    'data.company_name'() {
      if (this.data.company_name === 'regtest_123go') {
        this.autofillTestData()
      }
    },
    'data.phone'() {
      if (this.upgrade) {
        // this.data.phone = this.testData.phone?.replace(this.countries[this.testData.country].dialCode, '')
        // this.data.dialCode = this.countries[this.testData.country].dialCode
      }
    },
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
      this.availablePlatforms
    },
    isCompany() {
      if (!this.upgrade) {
        // Preserve the currently selected country before resetting
        const selectedCountry = this.data.country
        const selectedDialCode = this.data.dialCode
        // Reset form data when changing from individual to company or the other way round.
        this.data = {
          first_name: '',
          middle_name: '',
          last_name: '',
          country: this.detectedCountry? selectedCountry: '',
          company_name: '',
          website: '',
          dialCode: this.detectedCountry? selectedDialCode: '',
          phone: '',
          email: '',
          password: '',
          confirm_password: '',
          social_platform: '',
          other_social_platform: '',
        }
        this.$validator.reset()
        this.invalidEmail = false
        this.passwordsNotMatch = false
      }
    },
    prefilledTestData() {
      Object.keys(this.testData).forEach(key => {
        this.data[key] = this.testData[key]
      })
    },
  },
  beforeMount() {
    this.$nextTick(() => {
      if (this.formData.email) {
        Object.keys(this.formData).forEach(key => {
          // Don't override country if it was preselected from detected IP
          if (key === 'country' && this.data.country) return
          this.data[key] = this.formData[key]
        })
      }
    })
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      BonusConfig: 'bonusconfig/all',
      User: 'user/all',
    }),
    filteredCountries() {
      // Create working copy to avoid mutating config
      const workingCountries = { ...config.countries }

      // Countries to always show on upgrade from config
      const blockCountriesUponRegistration = config.blockCountriesUponRegistration || []

      // Filter logic:
      // - Normal registration: hide all hiddenCountries
      // - Upgrade: only hide hiddenCountries NOT in blockCountriesUponRegistration
      const keys = Object.keys(workingCountries)
      for (let i = 0; i < keys.length; i++) {
        const countryCode = keys[i]
        const shouldHide = this.hiddenCountries.includes(countryCode) && (!this.upgrade || !blockCountriesUponRegistration.includes(countryCode))

        if (shouldHide) {
          delete workingCountries[countryCode]
        }
      }

      return workingCountries
    },
    companyActive() {
      this.$validator.reset()
      return this.isCompany
    },
    countriesDialCodes() {
      return Object.entries(this.countries)
        .map(function ([code, country]) {
          return {
            countryCode: code, // unique key  used by track-by
            label: `${code} (+${country.dialCode})`,
            value: country.dialCode, // what gets stored in data.dialCode
            name: country.name, //used for filtering/searching
          }
        })
        .filter(function (o) {
          return o.value !== ''
        })
    },
    passwordValueMask() {
      return password => {
        let maskedResult = '*'.repeat(password.length)
        return maskedResult
      }
    },
    availablePlatforms() {
      return [
        { value: 'facebook', label: 'Facebook' },
        { value: 'instagram', label: 'Instagram' },
        { value: 'tiktok', label: 'TikTok' },
        { value: 'x', label: 'X (Twitter)' },
        { value: 'reddit', label: 'Reddit' },
        { value: 'forum', label: 'Forum' },
        { value: 'youTube', label: 'YouTube' },
        { value: 'telegram', label: 'Telegram' },
        { value: 'discord', label: 'Discord' },
        { value: 'threads', label: 'Threads' },
        { value: 'referred', label: this.$t('referred').tTitle() },
        { value: 'other', label: 'other_text' },
      ]
    },
  },
  methods: {
    checkEmailValidation() {
      this.invalidEmail = false
      if (this.data.email == '') {
        return
      }
      if (!this.$validateEmail(this.data.email.trim())) {
        this.invalidEmail = true
      }
    },
    validateConfirmPassword() {
      this.validateField('confirm_password')
      this.passwordsNotMatch = false
      if (this.data.password == '' || this.data.confirm_password == '') {
        return
      }
      if (this.data.password !== this.data.confirm_password) {
        this.passwordsNotMatch = true
      }
    },
    changePage() {
      // if (this.passwordsNotMatch && !this.upgrade) {
      //   return
      // }
      const dobFields = this.accountType.toLocaleLowerCase() === 'demo' ? [] : ['dob_day', 'dob_month', 'dob_year']
      const phoneFields = this.upgrade ? ['phone'] : ['phone', 'dialCode']
      const passwordFields = this.upgrade ? [] : ['password', 'confirm_password']
      const upgradeFields = [...phoneFields, ...passwordFields]

      const individualFields = this.upgrade
        ? ['first_name', 'middle_name', 'last_name', 'country', 'email', ...dobFields, ...upgradeFields]
        : ['first_name', 'middle_name', 'last_name', 'country', 'email', ...dobFields, ...upgradeFields]
      const companyFields = this.upgrade
        ? ['country', 'company_name', 'email', ...upgradeFields]
        : ['country', 'company_name', 'email', ...upgradeFields]

      this.$validator
        .validateAll(
         !this.isCompany ? individualFields : companyFields
        )
        .then(result => {
          if (result && !this.invalidEmail) {
            if (this.isRegisterRoute && !this.upgrade) {
              this.$bus.$emit('DataSubmitted', this.data)
              return this.$bus.$emit('ApiCall')
            } else {
              this.$bus.$emit('ChangePage', this.page + 1)
              this.$bus.$emit('DataSubmitted', this.data)
            }
            return
          }
          // scroll to first message
          let el = null
          if (this.errors.items.length > 0) el = document.getElementsByName(this.errors.items[0].field)[0]
          if (this.invalidEmail) el = document.getElementsByName('email')[0]
          if (el) return el.focus()
        })
    },
    autofillTestData() {
      this.$bus.$emit('fillWithTestData')
    },
    setDialCode() {
      this.data.dialCode = this.countries[this.data.country].dialCode
      this.$validator.validate('dialCode', this.data.dialCode)
    },
    passwordChanged(e, field) {
      if (field === 'confirm_password') this.validateField('password')
      const passLength = e.target.value.length
      const newCharacter = e.data
      const cursorPosition = e.target.selectionStart
      const password = this.data[field]
      const changeCount = password.length + 1 - passLength

      if (newCharacter === null) {
        // delete from a cursor position in the password
        if (cursorPosition >= 0) {
          this.data[field] = password.substring(0, cursorPosition) + password.substring(cursorPosition + 1)
        }
        // delete the whole password
        if (password.length === 1 || passLength === 0) {
          this.data[field] = ''
        }
        // delete selection from the password
        if (changeCount > 2) {
          this.data[field] = password.substring(0, cursorPosition) + password.substring(cursorPosition + changeCount - 1)
        }
      } else {
        if (password.length - e.target.value.length < -3) {
          this.data[field] = ''
        } else {
          if (cursorPosition === password.length + 1) {
            // add new char in the end of the password
            this.data[field] += newCharacter
          } else if (changeCount === 0) {
            // add new char in the position of the cursor
            this.data[field] = this.data[field].substring(0, cursorPosition - 1) + newCharacter + this.data[field].substring(cursorPosition - 1)
          } else {
            // replace multiple chars in the password
            this.data[field] = password.substring(0, cursorPosition - 1) + newCharacter + password.substring(changeCount + 1)
          }
          if (this.data[field].length !== passLength) {
            this.data[field] = this.data[field].substring(0, passLength)
          }
        }
      }
      setTimeout(() => {
        e.target.setSelectionRange(cursorPosition, cursorPosition)
      }, 0)
    },
    preselectCountryFromDetectedIP() {
      // Check if formData.country is empty/undefined/null
      const noFormDataCountry = !this.formData || !this.formData.country
      if (this.detectedCountry && noFormDataCountry) {
        this.$nextTick(() => {
          const isBlockedOrHidden = this.hiddenCountries.includes(this.detectedCountry) || config.blockCountriesUponRegistration?.includes(this.detectedCountry)
          if (isBlockedOrHidden) {
            this.data.country = 'ZZ'
          } else if (this.countries[this.detectedCountry]) {
            this.data.country = this.detectedCountry
          }
          // Dial code - as long as the detected country exists in our list, fill it in.
          if (this.countries[this.detectedCountry]) {
            this.data.dialCode = this.countries[this.detectedCountry].dialCode
            this.$refs.dialCode?.setSelectedByTrackKey(this.detectedCountry)
          }
        })
      } else {
        this.data.country = 'ZZ'
        this.data.dialCode = ''
      }
    },
    async validateField(field) {
      return await this.$validator.validate(field, this.data.field)
    },
    getCountryFlag(option) {
      return require(`@/assets/img/icons/flags/${option.countryCode.toLowerCase()}.png`)
   },
  },
}
</script>
<style scoped></style>
